import axios from 'axios';

export default {
  name: 'Relogin',
  methods: {
    relogin(username, rbxAuthToken) {
      axios.get('/changeUser', { params: { username } })
        .then((response) => {
          localStorage.removeItem(rbxAuthToken);
          localStorage.setItem(rbxAuthToken, response.data.token);

          window.open('/', '_self');
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
